import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styles from './styles/MobileMenuFooter.module.scss';

import { OmaLummeApp } from '../../omaLummeContext';

import Button from '../Common/Button';

// Icons.
import { facebookIcon, instagramIcon, linkedinIcon } from '../../icons';
import playBadge from '../../icons/google-play-badge.svg';
import appleBadge from '../../icons/app-store-badge.svg';
// Utils.
import { logUserOut } from '../../utils/login';
// Types.
import { useWindowSize } from './Header';

type MobileMenuFooterProps = {
  nav: {
    navOpen: boolean;
    toggleNavOpen: (value: React.SetStateAction<boolean>) => void;
  };
  userSwap: {
    userSwapOpen: boolean;
    toggleUserSwapOpen: (value: React.SetStateAction<boolean>) => void;
  };
};

const MobileMenuFooter: React.FunctionComponent<MobileMenuFooterProps> = (props: MobileMenuFooterProps) => {
  const { t } = useTranslation();

  const { users } = OmaLummeApp.useState();

  const { navOpen, toggleNavOpen } = props.nav;
  const { userSwapOpen, toggleUserSwapOpen } = props.userSwap;

  const windowWidth = useWindowSize()[0];
  const isMobile = windowWidth < 768;

  const isAppSource = localStorage.getItem('source') === 'app' ? true : false;
  return (
    <div className={`${styles.mobileMenuFooter} ${isAppSource ? styles.footerWithoutAppComponent : undefined}`}>
      {navOpen && !userSwapOpen && users.childUsers && (
        <Button
          className="buttonWhite"
          onClick={(): void => {
            toggleNavOpen(false);
            toggleUserSwapOpen(true);
          }}
        >
          {t('header:functional.swapUser')}
        </Button>
      )}
      <Button className="buttonWhite" onClick={(): void => logUserOut()}>
        {t('header:functional.logout')}
      </Button>

      {isMobile && (
        <div className={styles.socialMedia}>
          <a href="https://www.facebook.com/LummeEnergia" target="_blank" rel="noopener noreferrer">
            <img src={facebookIcon} alt="Facebook" />
          </a>
          <a href="https://www.instagram.com/lummeenergia/" target="_blank" rel="noopener noreferrer">
            <img src={instagramIcon} alt="Instagram" />
          </a>
          <a href="https://www.linkedin.com/company/lummeenergia" target="_blank" rel="noopener noreferrer">
            <img src={linkedinIcon} alt="LinkedIn" />
          </a>
        </div>
      )}

      {isMobile && (
        <p>
          <Trans i18nKey="header:navigation.questions" values={{ phoneNumber: t(`header:navigation.questionsPhoneNumber`) }}>
            .<a href={`tel:+358${t(`header:navigation.questionsPhoneNumber`).substring(1).replaceAll(' ', '')}`}></a>
          </Trans>
        </p>
      )}

      {isMobile && !isAppSource && (
        <div className={styles.app}>
          <h4>{t('landingPage:appCta.mobileTitle')}</h4>
          <a href={import.meta.env.VITE_GOOGLE_LINK} target="_blank" rel="noopener noreferrer">
            <img src={playBadge} alt="Google Play" />
          </a>
          <a href={import.meta.env.VITE_APPLE_LINK} target="_blank" rel="noopener noreferrer">
            <img src={appleBadge} alt="App Store" />
          </a>
        </div>
      )}
    </div>
  );
};

export default MobileMenuFooter;
